import { RotateLayout } from "@pdfking/filling-flex"
import { HALF_TURN } from "@pdfking/math/constants"
import { RecordByPrimaryKey } from "@pdfking/templates"

import type { JobProcessor } from "#internal"

import { AutobleedProcessor } from "../views/imposition/hooks/AutobleedProcessor"
import { BnProcessor } from "../views/imposition/hooks/BnProcessor"
import { HelpJobProcessor } from "../views/imposition/hooks/HelpJobProcessor"

/**
 * The marking hooks every host gets, by id. A host with markings of its own
 * spreads these into its list and hands it to its presets as `hooks_list`.
 */
export const HooksMarkingList = RecordByPrimaryKey<JobProcessor>([
  {
    id: "rotate",
    name: "MARKING_ROTATE",
    sequence: 0,
    // NOTE: Python `rotate` runs `s.rotate(180)` as its
    // `machine_size_processor` (objects/hooks/library.py:229); TS applies
    // it as an `imposition_processor` instead — a separate discrepancy
    // from the UV fix, left as-is for now.
    imposition_processor: (_ctx, current) => RotateLayout(current, HALF_TURN),
  },
  {
    id: "help",
    name: "MARKING_HELP",
    sequence: 0,
    final_job_processor: HelpJobProcessor,
    // The help sheet measures its grows, under a fill too.
    context_processor: ctx => ({ ...ctx, plot_measures: true }),
  },
  {
    id: "bn",
    name: "MARKING_BN",
    sequence: 0,
    color_processor: BnProcessor,
  },
  {
    id: "autobleed",
    name: "MARKING_AUTOBLEED",
    sequence: 0,
    media_processor: AutobleedProcessor,
  },
] satisfies JobProcessor[])
